import image1 from "./how to/1.png";
import image2 from "./how to/2.png";
import image3 from "./how to/3.png";

export default [image1, image2, image3];
